// src/services/budgetSubCategoryService.js
import axios from '@/api'

export default {
  getAll() {
    return axios.get('/budget-sub-categories')
  },
  get(id) {
    return axios.get(`/budget-sub-categories/${id}`)
  },
  create(data) {
    return axios.post('/budget-sub-categories', data)
  },
  update(id, data) {
    return axios.put(`/budget-sub-categories/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/budget-sub-categories/${id}`)
  }
}
